import { UIHeading4 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as style from './style.css';
import { EPageType } from '../../../types/page/pageType';

interface ITabProps {
  value: EPageType;
  pageType: EPageType;
  label: string;
  img: string;
  onChange: () => void;
}

export const Tab: React.FC<ITabProps> = ({ value, pageType, label, img, onChange }) => {
  return (
    <div
      onClick={onChange}
      className={cn(style['tab-item'], {
        [style['active-tenant']]: value === pageType && pageType === EPageType.Tenant,
        [style['active-homeowner']]: value === pageType && pageType === EPageType.Homeowner,
        [style['active-agent']]: value === pageType && pageType === EPageType.Agent,
      })}
    >
      <UIHeading4>{label}</UIHeading4>
      <img className={style['img']} src={img} />
    </div>
  );
};
